import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { fetchHoofdnetOpdracht } from '../services/fetchHoofdnetOpdracht'

export { useHoofdnetOpdracht }

const queryKey = 'hoofdnetopdracht'

const useHoofdnetOpdracht = ({ id }: { id: string }) => {
  const { hasPermissions } = useAuthenticatedUser()

  const {
    data,
    isPending: isLoading,
    isError,
  } = useQuery({
    queryFn: () => fetchHoofdnetOpdracht(id),
    queryKey: [queryKey, id],
    enabled: hasPermissions && !!id,
  })

  return {
    data,
    isLoading,
    isError,
  }
}
